import React from "react";
// import { FaFacebook, FaTwitter, FaInstagram, FaYoutube } from "react-icons/fa";
import { Divider, useMediaQuery } from "@mui/material";
import { Title, YouTube } from "@mui/icons-material";
import { FaInstagram, FaYoutube } from "react-icons/fa";
import { FaFacebook, FaTwitter, FaXTwitter } from "react-icons/fa6";
import { ArrowBack } from "@mui/icons-material"; // Import back arrow icon
import { useLocation, useNavigate } from "react-router-dom";
import blogImage from "../../../assets/images/Interview Preperation.jpg";

export default function WareHouseInterViewDetail() {
  const isMobile = useMediaQuery("(max-width:600px)");
  const state = useLocation();
  console.log(state, "acvasgvxgaf");

  const data = state.state;
  console.log(data, "assss");

  return (
    <div className="container-fluid justify-content-center px-3">
      <div className="mt-3">
        <div
          className="card shadow-md p-4 mt-3 mb-4 about-content"
          style={{ marginLeft: "14px" }}
        >
          <h4 className="fw-bold mb-4  ">{data.title}</h4>
          <div className=" mb-4 img-detail-interview ">
            <img src={blogImage} alt="" />
          </div>
          <h6 className="fw-bold   ">Blog Introduction</h6>
          <p className="">{data.blogIntroduction} </p>
          <h6 className="fw-bold   ">Blog Description</h6>
          <p className="">{data.description} </p>
          <h6 className="fw-bold   ">Key Preparation Steps</h6>
          <ul>
            {data.steps?.map((step, index) => (
              <li key={index}>{step}</li>
            ))}
          </ul>{" "}
          <h6 className="fw-bold  tip-bold ">Tip</h6>
          <p className="">{data.tip} </p>
        </div>
      </div>
    </div>
  );
}
